// extracted by mini-css-extract-plugin
module.exports = {"callout":"ReplyEditSubmitStatus-callout-2s-Ip"};